export default class WaypointProperties {
    name: string;
    comment: string|null;
    icon: string;
    colour: string;
    proximityAlarm: number|null;
    constructor(name: string, icon: string, colour: string, proximityAlarm: number|null, comment: string|null) {
        this.name = name;
        this.icon = icon;
        this.colour = colour;
        this.proximityAlarm = proximityAlarm;
        this.comment = comment;
    }
}